import React from "react";

interface Practitioner {
  name: string;
}

interface Summary {
  practitioner: Practitioner;
  specialty: string;
  startdate_healthcare: string;
  enddate_healthcare: string;
  doctor_note: string;
  diagnosis: string;
  file_url: string;
}

const Certificate: React.FC<{ summary: Summary }> = ({ summary }) => {
  return (
    <div
      style={{
        padding: "10px",
        border: "1px solid #ccc",
        borderRadius: "8px",
        backgroundColor: "#eaf4ff",
        fontSize: "12px",
        // fontFamily: "Arial, sans-serif",
        // width: "100%", // Lebar penuh
        boxSizing: "border-box", // Pastikan padding tidak menambah lebar elemen
      }}
    >
      <p style={{ margin: "0 0 10px", color: "#00bfa5", textAlign:"center" }}><b>Consultation Certificate</b></p>
      <hr style={{ border: "none", borderTop: "1px solid #ddd" }}  />
      <table>
        <tr>
          <td>Doctor</td>
          <td>:</td>
          <td>{summary.practitioner?.name || "N/A"}</td>
        </tr>
        <tr>
          <td>Speciality</td>
          <td>:</td>
          <td>{summary.specialty || "N/A"}</td>
        </tr>
      </table>
     
      <hr style={{ border: "none", borderTop: "1px solid #ddd" }} />
      <table>
        <tr>
          <td>Start Date</td>
          <td>:</td>
          <td>{summary.startdate_healthcare || "N/A"}</td>
        </tr>
        <tr>
          <td>End Date</td>
          <td>:</td>
          <td>{summary.enddate_healthcare || "N/A"}</td>
        </tr>
        <tr>
          <td>Notes</td>
          <td>:</td>
          <td>{summary.doctor_note || "N/A"}</td>
        </tr>
        <tr>
          <td>Diagnosa</td>
          <td>:</td>
          <td>{summary.diagnosis || "N/A"}</td>
        </tr>
        <tr>
          <td>Download File</td>
          <td>:</td>
          <td>  {summary.file_url ? (
                <a style={{textDecoration: "none"}} href={summary.file_url} target="_blank" rel="noopener noreferrer">
                  Certificate
                </a>
              ) : (
                "N/A"
              )}</td>
        </tr>
      </table>
    </div>
  );
};

export default Certificate;
